/**
 * View component for /nodes/:nodeId/update
 *
 * Updates a single node from a copy of the selcted node
 * as defined in the node reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as nodeActions from '../nodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import NodeForm from '../components/NodeForm.js.jsx';
import NodeLayout from '../components/NodeLayout.js.jsx';

// import node css modules
import nodeStyles from '../nodeModuleStyles.css';

class UpdateNode extends Base {
  constructor(props) {
    super(props);
    const { selectedNode, nodeMap } = this.props;
    this.state = {
      node: nodeMap[selectedNode.id] ? { ...nodeMap[selectedNode.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(nodeActions.fetchSingleIfNeeded(match.params.nodeId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedNode, nodeMap } = nextProps;
    this.setState({
      node: nodeMap[selectedNode.id] ? { ...nodeMap[selectedNode.id] } : {}
      //we don't want to actually change the store's node, just use a copy
    })
  }

  _handleFormChange(e) {
    let newNodeState = _.update( this.state.node, e.target.name, function() {
      return e.target.value;
    });
    this.setState({node :newNodeState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(nodeActions.sendUpdateNode(this.state.node)).then((action) => {
      if(action.success) {
        history.push(`/nodes/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedNode, nodeMap } = this.props;
    const { node } = this.state;
    const isEmpty = (!node || node._id === null || node._id === undefined);
    return  (
      <NodeLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedNode.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <NodeForm
                node={node}
                cancelLink={`/nodes/${node._id}`}
                formTitle="Update Node"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </NodeLayout>
    )
  }
}

UpdateNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedNode: store.node.selected
    , nodeMap: store.node.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateNode)
);



// WEBPACK FOOTER //
// modules/node/views/UpdateNode.js.jsx